import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import Download from '../../images/icons/download.svg'
import MoreInformation from '../../images/icons/more-light.svg'
import ArrowRight from '../../images/icons/arrow-right-tile.svg'
import Webcast from '../../images/icons/webcastPlay.svg'

export const StyleIconMore = styled(MoreInformation)`
  border: ${pxToRem(1)} solid ${({ theme }) => theme.colors.unique.black};
  border-radius: ${pxToRem(5)};
  vertical-align: middle;
`

export const StyledArrow = styled(ArrowRight)`
  width: ${pxToRem(25)};
  height: ${pxToRem(24)};
  padding: ${pxToRem(5)};
  border: ${pxToRem(1)} solid ${({ theme }) => theme.colors.unique.black};
  border-radius: ${pxToRem(5)};
  vertical-align: middle;
`

export const StyledWebcast = styled(Webcast)`
  width: ${pxToRem(25)};
  height: ${pxToRem(24)};
  padding: ${pxToRem(5)};
  border: ${pxToRem(1)} solid ${({ theme }) => theme.colors.unique.black};

  border-radius: ${pxToRem(5)};
  vertical-align: middle;
`

export const StyleIconDownload = styled(Download)`
  border: ${pxToRem(1)} solid ${({ theme }) => theme.colors.unique.black};
  border-radius: ${pxToRem(5)};
`

export const StyledButtonContainer = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;
  padding: 0;
`

export const StyledButtonDownload = styled.div`
  align-items: center;
  display: flex;
  transition: 0.2s all ease;
  font-size: ${({ theme }) => theme.fonts.sizes.button};
  line-height: ${({ theme }) => theme.fonts.lineHeight.button};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  color: ${({ theme }) => theme.colors.unique.black};
  flex-grow: 1;
  justify-content: space-between;
  flex-direction: row;
  height: ${pxToRem(50)};
  max-height: ${pxToRem(50)};
  padding-inline: ${pxToRem(10)};
  cursor: initial;
  border-radius: ${pxToRem(5)};
  border: ${({ theme }) =>
    `${pxToRem(2)} solid ${theme.colors.primary.blue}`};


  &:hover {
    border-color: ${({ theme }) => theme.colors.primary.blue};
    background-color: ${({ theme }) => theme.colors.unique.white};
  }

  &:hover
    ${StyledButtonContainer}
    > ${StyleIconMore},
    &:hover
    ${StyledButtonContainer}
    > ${StyleIconDownload} {
    background-color: ${({ theme }) => theme.colors.unique.black};
    fill: ${({ theme }) => theme.colors.unique.white};
  }
`

export const StyledButtonText = styled.a`
  flex-direction: column;
  justify-content: center;
  display: flex;

  max-width: calc(100% - ${pxToRem(39)});
  height: 100%;
`

export const StyledText = styled.span`
  display: inline-block;
  font-size: ${({ theme }) => theme.fonts.sizes.sm};
  line-height: ${({ theme }) => theme.fonts.lineHeight.sm};
  font-weight: ${({ theme }) => theme.fonts.weight.light};
  text-align: start;
  color: ${({ theme }) => theme.colors.unique.grey};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const StyledLabel = styled.span`
  display: inline-block;
  text-overflow: ellipsis;
  width: 100%;
  font-size: ${({ theme }) => theme.fonts.sizes.base};
  line-height: ${({ theme }) => theme.fonts.lineHeight.base};
  font-weight: ${({ theme }) => theme.fonts.weight.semibold};
  text-align: start;
  white-space: nowrap;
  overflow: hidden;
`

export const StyledWebcastContainer = styled.a`
  &:hover > ${StyledArrow}, &:hover > ${StyledWebcast} {
    background-color: ${({ theme }) => theme.colors.unique.black};
    path {
      fill: ${({ theme }) => theme.colors.unique.white};
    }
  }
`
